var _require = require('prettier/standalone'),
    _require$doc$builders = _require.doc.builders,
    group = _require$doc$builders.group,
    line = _require$doc$builders.line,
    concat = _require$doc$builders.concat,
    indent = _require$doc$builders.indent;

var comparison = require('./comparison.js');

var groupIfNecessaryBuilder = function groupIfNecessaryBuilder(path) {
  return function (doc) {
    var parentNode = path.getParentNode();

    if (parentNode.type === 'BinaryOperation' && !comparison.match(parentNode.operator)) {
      return doc;
    }

    return group(doc);
  };
};

var indentIfNecessaryBuilder = function indentIfNecessaryBuilder(path) {
  return function (doc) {
    var parentNode = path.getParentNode();

    if (parentNode.type === 'BinaryOperation' && !comparison.match(parentNode.operator)) {
      return doc;
    }

    return indent(doc);
  };
};

module.exports = {
  match: function match(op) {
    return ['+', '-', '*', '/', '%'].includes(op);
  },
  print: function print(node, path, _print) {
    var groupIfNecessary = groupIfNecessaryBuilder(path);
    var indentIfNecessary = indentIfNecessaryBuilder(path);
    return groupIfNecessary(indentIfNecessary(concat([path.call(_print, 'left'), ' ', node.operator, line, path.call(_print, 'right')])));
  }
};